import { useState } from 'react'
import { Popover, Button, BlockStack, Checkbox, Text, InlineStack } from '@shopify/polaris'

type Props = {
    chargeTaxes: boolean
    onSave: (chargeTaxes: boolean) => void
}

export function TaxPopover({ chargeTaxes: initial, onSave }: Props) {
    const [open, setOpen] = useState(false)
    const [chargeTaxes, setChargeTaxes] = useState(initial)

    const handleDone = () => {
        onSave(chargeTaxes)
        setOpen(false)
    }

    const handleCancel = () => {
        setChargeTaxes(initial)
        setOpen(false)
    }

    return (
        <Popover
            active={open}
            activator={
                <Button variant="plain" onClick={() => setOpen(v => !v)}>Estimated tax</Button>
            }
            onClose={() => setOpen(false)}
        >
            <Popover.Section>
                <BlockStack gap="300">
                    <Text as="p" tone="subdued" variant="bodySm">Taxes are automatically calculated.</Text>
                    <Checkbox
                        label="Charge taxes"
                        checked={chargeTaxes}
                        onChange={setChargeTaxes}
                    />
                    <InlineStack gap="200">
                        <Button size="slim" onClick={handleCancel}>Cancel</Button>
                        <Button size="slim" variant="primary" onClick={handleDone} disabled={chargeTaxes === initial}>Done</Button>
                    </InlineStack>
                </BlockStack>
            </Popover.Section>
        </Popover>
    )
}
